/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type TaskReportTableV2_viewer = {
    readonly reportData: {
        readonly totals: {
            readonly taskTotals: {
                readonly entities: number | null;
                readonly work: {
                    readonly estimate: {
                        readonly minutes: number | null;
                        readonly points: number | null;
                    } | null;
                    readonly remaining: {
                        readonly minutes: number | null;
                        readonly points: number | null;
                    } | null;
                } | null;
                readonly reported: {
                    readonly time: number | null;
                    readonly points: number | null;
                    readonly projected: number | null;
                } | null;
                readonly financial: {
                    readonly revenue: {
                        readonly planned: number | null;
                        readonly actual: number | null;
                    } | null;
                } | null;
            } | null;
        } | null;
    } | null;
    readonly " $refType": "TaskReportTableV2_viewer";
};
export type TaskReportTableV2_viewer$data = TaskReportTableV2_viewer;
export type TaskReportTableV2_viewer$key = {
    readonly " $data"?: TaskReportTableV2_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"TaskReportTableV2_viewer">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "minutes",
    "storageKey": null
  },
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "searchQuery",
      "type": "TaskSearchQueryType"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "reportId",
      "type": "String"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "sharedId",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TaskReportTableV2_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "reportId"
        },
        {
          "kind": "Variable",
          "name": "sharedId",
          "variableName": "sharedId"
        }
      ],
      "concreteType": "ReportData",
      "kind": "LinkedField",
      "name": "reportData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "searchQuery",
              "variableName": "searchQuery"
            }
          ],
          "concreteType": "ReportTotals",
          "kind": "LinkedField",
          "name": "totals",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ReportTaskTotals",
              "kind": "LinkedField",
              "name": "taskTotals",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "entities",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskReportTableTask_GroupWork",
                  "kind": "LinkedField",
                  "name": "work",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TaskReportTableTask_Unit",
                      "kind": "LinkedField",
                      "name": "estimate",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TaskReportTableTask_Unit",
                      "kind": "LinkedField",
                      "name": "remaining",
                      "plural": false,
                      "selections": (v1/*: any*/),
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TaskReportTableTask_Reported",
                  "kind": "LinkedField",
                  "name": "reported",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "time",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "projected",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ReportTotalsFinancial",
                  "kind": "LinkedField",
                  "name": "financial",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TaskReportTableTask_Revenue",
                      "kind": "LinkedField",
                      "name": "revenue",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "planned",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "actual",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
})();
(node as any).hash = '64315580147162926f5fb6136b67bb50';
export default node;
